import request from "src/api/request-manager/gateway";

import type {
  AuthenticateUserData,
  AuthenticateUserResponse,
  GetRegisteredCompaniesResponse,
  LoginUserData,
  LoginUserResponse
} from "./types/authentication.types";

const prefixURL = "/dashboard/v1";

const AuthenticationAPI = {
  authenticateUser(data: AuthenticateUserData): Promise<AuthenticateUserResponse> {
    return request.post<AuthenticateUserResponse>(`${prefixURL}/user/authenticate`, data);
  },
  getRegisteredCompanies(token: string): Promise<GetRegisteredCompaniesResponse> {
    return request.get<GetRegisteredCompaniesResponse>(
      `${prefixURL}/user/registered-companies`,
      {},
      { Authorization: `Bearer ${token}` }
    );
  },
  loginUser(data: LoginUserData, token: string): Promise<LoginUserResponse> {
    return request.post<LoginUserResponse>(`${prefixURL}/user/new-login`, data, {
      Authorization: `Bearer ${token}`
    });
  }
};

export default AuthenticationAPI;
